import { Routes, RouterModule } from '@angular/router';
import { ResultsComponent } from './results.component';
import { AuthCheckComponent } from '../auth-check/auth.check.component';

const SUBPAGE_ROUTES: Routes = [
  { path: '', component: ResultsComponent },
  { path: '**', component: AuthCheckComponent }
];

export const ResultsRoutingModule = RouterModule.forChild(SUBPAGE_ROUTES);
